import React, { useRef, useState } from 'react';
import { TextInput, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { useForm } from 'react-hook-form';
import CustomButton from '../../components/CustomButton';
import { translate } from '../../services/translate';
import RtcMediaPlayer, { ConnectionState, RtcMediaPlayerRef } from '../../components/RtcMediaPlayer';
import MyAppText from '../../components/MyAppText';
import Toast from 'react-native-toast-message';

interface PublisherForm {
    url: string;
    fps: number;
    idealWidth: number;
    maxWidth: number;
}

export default function Publisher() {
    const { styles } = useStyles(styleSheet);

    const rtcRef = useRef<RtcMediaPlayerRef>(null);
    const [connectionState, setConnectionState] = useState<ConnectionState>();

    const defaultEmptyValues: PublisherForm = {
        url: 'https://srs000009.stage-webrtc-servers.stage.sentinelx.com.br/rtc/v1/whip/?app=live&stream=pwa',
        fps: 3,
        idealWidth: 320,
        maxWidth: 576,
    };

    const form = useForm<PublisherForm>({
        defaultValues: defaultEmptyValues,
    });

    async function publish() {
        try {
            const values = form.getValues();
            const data = await rtcRef.current?.publish(values);

            console.log(data);

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return <View style={styles.container}>
        <View style={styles.headerContent}>
            <View style={{ flex: 1 }}>
                <TextInput
                    style={[styles.textInput, styles.textColor(form.watch('url'))]}
                    value={form.watch('url')}
                    onChangeText={value => form.setValue('url', value)}
                    placeholder={'URL'}
                />
            </View>
            <CustomButton
                onPress={publish}
                text={translate('publish')}
            />
        </View>
        <View style={styles.headerContent}>
            <View>
                <MyAppText style={styles.label}>{'FPS'}</MyAppText>
                <TextInput
                    style={[styles.textInput, styles.textColor(String(form.watch('fps')))]}
                    value={String(form.watch('fps'))}
                    onChangeText={value => {
                        value = value.replace(/[^0-9]/g, '');

                        form.setValue('fps', Number(value));
                    }}
                    placeholder={'FPS'}
                />
            </View>
            <View>
                <MyAppText style={styles.label}>{translate('idealWidth')}</MyAppText>
                <TextInput
                    style={[styles.textInput, styles.textColor(String(form.watch('idealWidth')))]}
                    value={String(form.watch('idealWidth'))}
                    onChangeText={value => {
                        value = value.replace(/[^0-9]/g, '');

                        form.setValue('idealWidth', Number(value));
                    }}
                    placeholder={translate('idealWidth')}
                />
            </View>
            <View>
                <MyAppText style={styles.label}>{translate('maxWidth')}</MyAppText>
                <TextInput
                    style={[styles.textInput, styles.textColor(String(form.watch('maxWidth')))]}
                    value={String(form.watch('maxWidth'))}
                    onChangeText={value => {
                        value = value.replace(/[^0-9]/g, '');

                        form.setValue('maxWidth', Number(value));
                    }}
                    placeholder={translate('maxWidth')}
                />
            </View>
        </View>
        <View style={styles.cardList}>
            <MyAppText>State: {connectionState}</MyAppText>
            <RtcMediaPlayer
                setConnectionState={setConnectionState}
                ref={rtcRef}
            />
        </View>
    </View>;
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flex: 1,
    },
    label: {
        fontSize: 16,
        height: 25,
    },
    textInput: {
        fontFamily: 'Open Sans',
        backgroundColor: theme.colors.container.background,
        borderWidth: 1,
        borderRadius: 4,
        borderColor: theme.colors.container.border,
        height: 40,
        minHeight: 40,
        fontSize: 16,
        padding: 10
    },
    textColor: (text?: string) => ({
        color: text ? theme.colors.field.text : theme.colors.disabledText
    }),
    headerContent: {
        flexDirection: 'row',
        minHeight: 65,
        zIndex: 2,
        flexWrap: 'wrap',
        gap: 15,
        // justifyContent: 'space-between',
        alignItems: 'center'
    },
    cardList: {
        borderWidth: 1,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        borderColor: theme.colors.container.border,
        backgroundColor: theme.colors.container.background,
        paddingHorizontal: 10,
        flex: 1
    },
}));
